import {Admin, Courier, Default, Moderator, Monitoring} from "@/enums/user.type";

export default class {
    _id;
    _name;
    _username;
    _type;

    _organization;
    _unit;

    _canSignOnBehalfOfOrganization;
    _unitIds;

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }


    get name() {
        return this._name
    }

    set name(value) {
        this._name = value
    }

    get username() {
        return this._username
    }

    set username(value) {
        this._username = value
    }

    get organization() {
        return this._organization
    }

    set organization(value) {
        this._organization = value
    }

    get isDefault() {
        return this.type === Default
    }

    get isAdmin() {
        return this.type === Admin
    }

    get isCourier() {
        return this.type === Courier
    }

    get isModerator() {
        return this.type === Moderator
    }

    get isMonitoring() {
        return this.type === Monitoring
    }

    get type() {
        return this._type;
    }

    set type (value) {
        this._type = value;
    }

    get unit() {
        return this._unit
    }

    set unit(value) {
        this._unit = value
    }

    get canSignOnBehalfOfOrganization() {
        return this._canSignOnBehalfOfOrganization;
    }

    set canSignOnBehalfOfOrganization(value) {
        this._canSignOnBehalfOfOrganization = value;
    }

    get unitIds() {
        return this._unitIds;
    }

    set unitIds(value) {
        this._unitIds = value;
    }

}